import React, { useState, useContext, useRef, useLayoutEffect, useEffect } from "react";
import apiClient from "../../ApiEndpoint/apiClient";
import Sidebar from "../Sidebar/sidebar";
import "./home.css";
import ReactMarkdown from "react-markdown";
import apiUrl from "../../ApiEndpoint/config";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";
import { Modal, Tabs, Input } from 'antd';
import { getFromDB, setToDB, STORE_NAMES } from "./../../utils/indexedDBUtil";
import { useAuthContext } from "../../utils/AuthContext";
import avatar from "../../assets/avatar.png";

import { Link as RouterLink, useNavigate } from 'react-router-dom';
const remarkGfm = require('remark-gfm').default || require('remark-gfm');


const Home = () => {
  const { user } = useAuthContext();
  const [inputText, setInputText] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [webToggle, setWebToggle] = useState('0');
  const { messages, setMessages, moveToBottom, setMoveToBottom, showWelcome, setShowWelcome, fetchSessionsFn, setGroupName } = useContext(RegisterIdContext);
  const bottomRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [promptSearchText, setPromptSearchText] = useState("");
  const [categories, setCategories] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [isPromptLoading, setIsPromptLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState(0);

  const socketRef = useRef(null);
  //Modal toggle
  const handleModalChange = () => {
    setIsModalVisible(true);
  };


  //Helper to group prompts by category:
  const getPromptsByCategory = (category) =>
    prompts.filter(
      (p) =>
        p.category === category &&
        p.title.toLowerCase().includes(promptSearchText.toLowerCase())
    );

  useEffect(() => {
    const fetchPromptData = async () => {
      setIsPromptLoading(true);

      try {
        // Step 1: Try fetching from IndexedDB first
        const cachedCategories = await getFromDB(STORE_NAMES.CATEGORIES, 'list');
        const cachedPrompts = await getFromDB(STORE_NAMES.PROMPTS, 'list');

        if (cachedCategories?.length && cachedPrompts?.length) {
          setCategories(cachedCategories);
          setPrompts(cachedPrompts);
          setActiveTabKey(cachedCategories[0]); // Set to first category
          setIsPromptLoading(false);
          return;
        }

        // Step 2: If cache not available, fetch from API
        const [catRes, promptRes] = await Promise.all([
          apiClient.get(`${apiUrl}/get_categories`),
          apiClient.get(`${apiUrl}/get_prompts`)
        ]);

        const catData = catRes.data || [];
        const promptData = promptRes.data || [];

        setCategories(catData);
        setPrompts(promptData);

        if (catData.length > 0) {
          setActiveTabKey(catData[0]);
        }

        // Step 3: Save to IndexedDB for future use
        await setToDB(STORE_NAMES.CATEGORIES, 'list', catData);
        await setToDB(STORE_NAMES.PROMPTS, 'list', promptData);

      } catch (err) {
        console.error("Error loading prompt data:", err);
      } finally {
        setIsPromptLoading(false);
      }
    };

    fetchPromptData();
  }, []);






  const navigate = useNavigate();


  // Scroll to bottom after messages update
  useLayoutEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [messages]);


  const handleCheckboxChange = (e) => {
    setWebToggle(e.target.checked ? '1' : '0'); // Set to '1' if checked, else '0'
  };



  // ✅ Setup WebSocket connection once
  useEffect(() => {
    let wsUrl = "wss://unlogical-superprecariously-shanae.ngrok-free.dev/askme";
    // let wsUrl = "ws://localhost:8000/askme";
    //let wsUrl = 'wss://4a7549c9c8c2.ngrok-free.app/askme'
    // let wsUrl;
    // if (window.location.hostname === "localhost") {
    //   // Local dev
    //   // wsUrl = apiUrl.replace(/^http/, "ws");
    //   // wsUrl = wsUrl.replace(/\/$/, "") + "/askme";
    //   // wsUrl = "ws://localhost:8000/askme"

    // } else {
    //   // Live API Gateway
    //   wsUrl = "https://d91850ebdaec.ngrok-free.app/askme";
    // }

    socketRef.current = new WebSocket(wsUrl);

    socketRef.current.onopen = () => {
    };

    socketRef.current.onmessage = (event) => {
      let data;
      try {
        data = JSON.parse(event.data);
      } catch {
        data = { result: event.data }; // fallback for plain text
      }

      if (data.session_id) {
        sessionStorage.setItem("currentSessionId", data.session_id);
        if (fetchSessionsFn) fetchSessionsFn();
      }

      // ✅ Handle streaming chunks
      if (data.type === "chunk") {
        setMessages((prev) => {
          const last = prev[prev.length - 1];
          if (last?.sender === "bot" && !last.complete) {
            const updated = [...prev];
            updated[updated.length - 1].text += data.content;
            return updated;
          } else {
            return [...prev, { text: data.content, sender: "bot", complete: false }];
          }
        });
      }

      // ✅ Handle end of stream
      if (data.type === "end") {
        setMessages((prev) => {
          const updated = [...prev];
          if (updated.length > 0) {
            updated[updated.length - 1].complete = true;
          }
          return updated;
        });
        setIsTyping(false);
      }

      // ✅ Handle fallback non-streamed message
      if (!data.type) {
        const botMessage = {
          text: data.result && data.result.trim() !== ""
            ? data.result
            : "Sorry, I couldn't find any response.",
          sender: "bot",
          complete: true
        };
        setMessages((prev) => [...prev, botMessage]);
        setIsTyping(false);
      }
    };

    socketRef.current.onclose = () => {
    };

    return () => {
      socketRef.current && socketRef.current.close();
    };
  }, [apiUrl, fetchSessionsFn]);

  // ✅ Handle sending messages
  // const handleSendMessage = async () => {
  //   if (inputText.trim() === "") return;

  //   const userMessage = { text: inputText, sender: "user" };
  //   setMessages((prev) => [...prev, userMessage]);
  //   setInputText("");
  //   setMoveToBottom(true);
  //   setShowWelcome(false);
  //   setIsTyping(true);

  //   const userEmail = user?.email;
  //   const currentSessionId = sessionStorage.getItem("currentSessionId");

  //   // Payload for WS or REST
  //   const payload = {
  //     // action: "askme",
  //     query: inputText,
  //     user_email: userEmail,
  //     // web_toggle: webToggle,
  //     flag: parseInt(selectedOption, 10)
  //   };
  //   if (currentSessionId) payload.session_id = currentSessionId;

  //   try {
  //     // --- Use WebSocket if connected ---
  //     if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
  //       socketRef.current.send(JSON.stringify(payload));
  //     } else {
  //       // --- Fallback to REST ---
  //       const response = await apiClient.get(`${apiUrl}/ask`, { params: payload });

  //       const botText = response.data.result || "No response received.";

  //       if (!currentSessionId && response?.data.session_id) {
  //         sessionStorage.setItem("currentSessionId", response?.data.session_id);
  //         if (fetchSessionsFn) fetchSessionsFn();
  //       }

  //       const botMessage = { text: botText, sender: "bot" };
  //       setMessages((prev) => [...prev, botMessage]);
  //       setIsTyping(false);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching response:", error);
  //     const errorResponse = {
  //       text: "Sorry, I couldn't get a response.",
  //       sender: "bot",
  //     };
  //     setMessages((prev) => [...prev, errorResponse]);
  //     setIsTyping(false);
  //   }
  // };
  const handleSendMessage = async () => {
    if (inputText.trim() === "") return;

    const userMessage = { text: inputText, sender: "user" };
    setMessages((prev) => [...prev, userMessage]);
    setInputText("");
    setMoveToBottom(true);
    setShowWelcome(false);
    setIsTyping(true);

    const userEmail = user?.email;
    const currentSessionId = sessionStorage.getItem("currentSessionId");

    // Build query params exactly like your cURL
    const queryParams = new URLSearchParams({
      query: inputText,
      user_email: userEmail,
      // flag: selectedOption.toString(),
      flag: parseInt(selectedOption, 10)
    });
    if (currentSessionId) {
      queryParams.append("session_id", currentSessionId);
    }

    try {
      const response = await apiClient.post(
        `${apiUrl}/askme?${queryParams.toString()}`,
        {}, // empty body
        {
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem("access_token") || ""}`,
            "accept": "application/json"
          }
        }
      );

      const botText = response.data.result || "No response received.";

      // Save session_id if not already present
      if (!currentSessionId && response?.data.session_id) {
        sessionStorage.setItem("currentSessionId", response.data.session_id);
        if (fetchSessionsFn) fetchSessionsFn();
      }

      const botMessage = { text: botText, sender: "bot" };
      setMessages((prev) => [...prev, botMessage]);
      setIsTyping(false);

    } catch (error) {
      console.error("Error fetching response:", error);
      const errorResponse = {
        text: "Sorry, I couldn't get a response.",
        sender: "bot",
      };
      setMessages((prev) => [...prev, errorResponse]);
      setIsTyping(false);
    }
  };


  // ✅ Send on Enter
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const handleSessionSelect = async (sessionId) => {
    const userEmail = user?.email;
    if (!userEmail) return;

    try {
      const res = await apiClient.get(`${apiUrl}/get_session_history`, {
        params: { user_email: userEmail, session_id: sessionId }
      });

      const formattedMessages = res.data.map((entry) => ({
        text: entry.content,
        sender: entry.role === "user" ? "user" : "bot"
      }));

      setMessages(formattedMessages);
      setShowWelcome(false);
      setMoveToBottom(true);
    } catch (err) {
      console.error("Failed to load session history", err);
    }
  };

  const fixMarkdownTables = (text) => {
    // Replace escaped newlines with actual newlines
    let fixed = text.replace(/\\n/g, '\n');

    // Fix accidental double pipes between header and separator
    fixed = fixed.replace(/(\|[^\n]+)\|\s*\|(-{2,})/g, '$1\n$2');

    // If someone added `|` at the start of separator line again, fix that
    fixed = fixed.replace(/\n\|(-{2,})/g, '\n$1');

    return fixed;
  }
  const renderMarkdownLink = ({ href, children }) => {
    const cleanHref = href?.startsWith("/action:") ? href.slice(1) : href;

    if (cleanHref?.startsWith("action:")) {
      const parts = cleanHref.split(":");
      const type = parts[1];
      const value = parts.slice(2).join(":");
      setGroupName(null); // Set group name for navigation

      return (
        <RouterLink
          to="/smart-prospecting/data"
          state={type === "facility" ? { registryId: value } : { company: value }}
          style={{ color: "#1a73e8", textDecoration: "underline" }}
        >
          {children}
        </RouterLink>
      );
    }

    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-2 col-lg-4 col-md-4 col-2">
          <Sidebar onSessionSelect={handleSessionSelect} isTyping={isTyping} />
        </div>
        <div className="col-xl-10 col-lg-8 col-md-8 col-10 p-0">
          <div className="container-fluid d-flex flex-column justify-content-center align-items-center chat-container p-0">
            {showWelcome && (
              <div className="welcome-text">
                <h5 style={{ color: "#55555A", textAlign: "center" }}>
                  Welcome to the
                </h5>
                <h3>Veolia Smart Growth Engine - SIB</h3>
              </div>
            )}

            <div className="messages-container">
              {messages.map((msg, index) => (
                <div key={index} className={`message ${msg.sender}`}>
                  {msg.sender === "bot" ? (
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      components={{ a: renderMarkdownLink }}
                    >
                      {fixMarkdownTables(msg.text)}
                    </ReactMarkdown>
                  ) : (
                    msg.text
                  )}
                </div>
              ))}
              {isTyping && (
                <div className="typing-indicator">
                  <img src={avatar} alt="Chat" style={{ width: '2rem', height: '2rem', cursor: 'pointer' }} />
                  Neo is thinking
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              )}
              <div ref={bottomRef} />
            </div>

            <div
              className={`textarea-container ${moveToBottom ? "move-bottom" : "center-textarea"
                }`}
            >
              <textarea
                className="form-control fixed-height"
                rows="3"
                id="floatingTextarea"
                placeholder="How can I help?"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={handleKeyDown}
              ></textarea>

              <div
                className="btn-group"
                role="group"
                style={{
                  top: "50px",
                  right: "190px",
                  height: "95px",
                  zIndex: 10,
                }}
              >
                <select
                  style={{
                    width: '8rem',
                    height: '32px',
                    borderColor: '#dee2e6',
                    fontSize: '12px',
                    color: '#666f86'

                  }}
                  className="form-select textarea-dropdown"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}

                >
                  <option value="0">All</option>
                  <option value="1">Web Search</option>
                  <option value="2">EPA </option>
                  <option value="3">Salesforce</option>
                  <option value="4">IIR</option>
                  <option value="5">Building </option>
                  <option value="6">SEC </option>
                  <option value="7">Microgrid </option>
                  <option value="8"> CHP </option>
                </select>
                <input
                  type="checkbox"
                  className="btn-check"
                  id="btncheck1"
                  autoComplete="off"
                  checked={webToggle === "1"}
                  onChange={handleCheckboxChange}
                />
                {/* <label className="btn btn-outline-primary p-1 web-search-icon" htmlFor="btncheck1">
                  <i className="bi bi-globe" title="web search"></i>
                </label> */}
                <span style={{ marginLeft: '10px' }}>
                  {/* <label className="btn btn-outline-primary p-1 prompt-library-icon" htmlFor="btncheck2" >
                    <i class="bi bi-pencil-square" title="prompt library" onClick={handleModalChange}></i>
                  </label> */}
                  <label
                    className={`btn btn-outline-secondary p-1 prompt-library-icon ${isPromptLoading ? 'disabled' : ''}`}
                    htmlFor="btncheck2"
                    style={{ pointerEvents: isPromptLoading ? "none" : "auto", opacity: isPromptLoading ? 0.5 : 1 }}
                  >
                    <i className="bi bi-pencil-square" title="prompt library" onClick={handleModalChange}></i>
                  </label>
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>

      <Modal
        title="Prompt Suggestions"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1000}
        className="tall-modal"
      >


        {/* Tabs on the left, filtered prompt list on right */}
        <Tabs
          activeKey={activeTabKey}
          onChange={(key) => setActiveTabKey(key)}
          tabPosition="left"
          style={{ height: 500, overflowY: "scroll" }}
          items={categories.map((cat) => ({
            key: cat,
            label: cat,
            children: (
              <div>
                {getPromptsByCategory(cat).length > 0 ? (
                  getPromptsByCategory(cat).map((prompt, idx) => (
                    <div key={idx} className="prompt-card" style={{ marginBottom: 16 }}>
                      <h5><strong>{prompt.title}</strong></h5>
                      <textarea
                        style={{ width: "100%", height: 140, resize: "vertical" }}
                        defaultValue={prompt.prompt?.trim()}
                        onChange={(e) => prompt.edited = e.target.value}
                      />
                      <button
                        className="btn btn-sm btn-primary mt-2"
                        onClick={() => {
                          setInputText(prompt.edited || prompt.prompt?.trim());
                          setIsModalVisible(false);
                        }}
                      >
                        Use this prompt
                      </button>
                    </div>
                  ))
                ) : (
                  <p>No matching prompts found.</p>
                )}
              </div>
            )
          }))}
        />
      </Modal>




    </div >
  );
};
export default Home;
